import axios from "axios";

export default {
    create(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/rating",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllByProfessional(professionalId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/rating/professional/" +
                professionalId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getExcel(organizationId, data) {
        return axios({
            method: "post",
            responseType: "blob",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/rating/organization/" +
                organizationId +
                "/excel",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
